import React, { Component } from 'react'

export class about extends Component {
  render() {
    return (
        <div id="about">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-md-6"> <img src="img/aboutus.jpg" className="img-responsive" alt="electroskillsengineering"/> </div>
            <div className="col-xs-12 col-md-6">
              <div className="about-text">
                <h2>About Us</h2>
                <p>{this.props.data ? this.props.data.paragraph : 'loading...'}</p>
                <h3>Why Choose Us?</h3>
                
                  
                  <p>The intention of this course is to approach the PLC as a tool in automation and process control with an emphasis on the different techniques and approaches that should be followed in using it effectively. This approach is distinct from other course, which concentrates on the PLC fundamentals such as the basic instruction sets and the hardware requirements.</p>
                    {/* <ul>
                      {this.props.data ? this.props.data.Why.map((d, i) => <li  key={`${d}-${i}`}>{d}</li>) : 'loading'}
                    </ul>
                  </div>
                  <div className="col-lg-6 col-sm-6 col-xs-12">
                    <ul>
                    {this.props.data ? this.props.data.Why2.map((d, i) => <li  key={`${d}-${i}`}> {d}</li>) : 'loading'}

                    </ul> */}
                  
                
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default about
